<template>
  <div>

    <span v-if="wizardData.price_type===0">
      <v-divider class="mb-4"></v-divider>
      <v-row dense class="mb-4">
        <v-col cols="12" span="12">
          <v-icon color="success" medium class="avatar-icon">mdi-surround-sound-2-1</v-icon><span class="pl-4 font-weight-light"><i>Manually set minimum price calculation</i></span>
        </v-col>        
      </v-row>
    </span>

    <v-row dense no-gutters cols="12">      
      <v-col cols="5">
        <v-row dense>
          <v-col cols="12">
            <re_radioset :value="wizardData.minpurchase_relative" field="minpurchase_relative" @updateData="updateData"/>
          </v-col>
        </v-row>
        <v-row dense class="ml-3">
          <div v-if="wizardData.minpurchase_relative===true">
          <hsnp_wizard_step_02_minpurchase_relative :wizardData="wizardData" @updateData="updateData" class="ml-3"/>
        </div>
        <div v-else>
          <hsnp_wizard_step_02_minpurchase_exact :wizardData="wizardData" @updateData="updateData" :showToggle="wizardData.price_type!==0" class="ml-3"/>
        </div>
        </v-row>
      </v-col>
      <v-col cols="6" class="mt-3">
        <weekdays :days="wizardData.minpurchase_days" color="primary" field="minpurchase_days" @updateData="updateData" class="ml-3"/>
      </v-col>
    </v-row>

  </div>      
</template>

<script>

  
  import weekdays from '@/components/huis/hspt/ui/weekdays.vue'
  import re_radioset from '@/components/huis/hspt/ui/re_radioset.vue';
  import hsnp_wizard_step_02_minpurchase_relative from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_minpurchase_relative.vue';
  import hsnp_wizard_step_02_minpurchase_exact from '@/components/huis/hspt/hsnp/hsnp_wizard_step_02_minpurchase_exact.vue';  

  export default {
    props: {
      wizardData: Object
    },
    components: {
      weekdays,
      re_radioset,
      hsnp_wizard_step_02_minpurchase_relative,
      hsnp_wizard_step_02_minpurchase_exact,
    },
    methods:{
      updateData(data){
        this.$emit('updateData', data);      //
      }      
    }

  }
</script>

<style scoped>
  .avatar-icon{
    border-radius: 200px;
    width: 30px;
    height: 30px;
    border: solid 2px green;
  }
</style>